import { Id, toast, ToastOptions } from 'react-toastify';

type NotificationKind = 'error' | 'warn' | 'success' | 'info';

const priorities: Record<NotificationKind, number> = {
    info: 1,
    success: 2,
    warn: 3,
    error: 4,
};

let currentNotification: { id: Id; kind: NotificationKind; message: string } | null = null;

const show = (kind: NotificationKind, message: string, options?: ToastOptions) => {
    const toastId = `notification:${message}`;
    const currentIsActive = currentNotification !== null && toast.isActive(currentNotification.id);

    if (currentIsActive && currentNotification?.message === message) return;

    if (
        currentIsActive &&
        currentNotification &&
        priorities[kind] < priorities[currentNotification.kind]
    ) {
        return;
    }

    if (currentIsActive && currentNotification) {
        toast.dismiss(currentNotification.id);
    }
    toast.clearWaitingQueue();

    const id = toast[kind](message, { ...options, toastId });
    currentNotification = { id, kind, message };
};

export const notify = {
    error: (message: string, options?: ToastOptions) => show('error', message, options),
    warn: (message: string, options?: ToastOptions) => show('warn', message, options),
    success: (message: string, options?: ToastOptions) => show('success', message, options),
    info: (message: string, options?: ToastOptions) => show('info', message, options),
};